module.exports = __webpack_public_path__ + "img/Illustration 13@1x.56e280a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Illustration 13@1x.png
// module id = 1753
// module chunks = 1